var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BackofficeLayout',{attrs:{"title":_vm.$t('message.qualifiedApplicants.header')}},[_c('QualifiedApplicant')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }